import * as Sentry from "@sentry/browser"
import config from "config"
import { CurrentUser } from "graphql/smart-queries/user"

export const configureSentry = () => {
  if (config.integrations.sentry.dsn) {
    Sentry.init({
      dsn: config.integrations.sentry.dsn,
      release: config.app.version
    })
  }
}

export const setSentryScope = ({ email, id }: CurrentUser) => {
  Sentry.configureScope(scope => {
    scope.setUser({
      email: String(email),
      id: String(id)
    })
  })
}
